import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43280502"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "home-component" }
const _hoisted_2 = { class: "container-fluid px-0" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 d-flex justify-content-center px-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo-theme" })
], -1))
const _hoisted_5 = { class: "col-12 info-col px-3" }
const _hoisted_6 = { id: "test-name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "open-sans-font info-test" }, " Realize o autoteste HIV de forma segura e guiada. Inicie o passo a passo clicando abaixo. ", -1))
const _hoisted_8 = { class: "col-12 test-image-container" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col-12 pt-4 px-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title-text pt-4" }, "Por que fazer o teste é importante?"),
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle-text" }, " Entenda como o autoteste funciona, para quais situações é indicado e fatores que você deve ter atenção. ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iframe-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "iframe-wrapper" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "iframe-position" }, [
      /*#__PURE__*/_createElementVNode("iframe", {
        src: "https://player.vimeo.com/video/780449911?h=f671a2eaac",
        width: "100%",
        height: "200",
        mozallowfullscreen: "",
        webkitallowfullscreen: "",
        frameborder: "0",
        allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: ""
      }, "\n            ")
    ])
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title-text pt-3" }, "Ainda não tem o Autoteste HIV?"),
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle-text" }, " Você encontrará o autoteste HIV em farmácias físicas ou online. ")
], -1))
const _hoisted_14 = { class: "col-12 px-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 btn-find-pharmacy" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle-text" }, " Gostaria de realizar o teste acompanhado de um profissional de saúde? ")
], -1))
const _hoisted_16 = { class: "col-12 px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonStartTest = _resolveComponent("ButtonStartTest")!
  const _component_ButtonExternalLink = _resolveComponent("ButtonExternalLink")!
  const _component_base_footer = _resolveComponent("base-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.testName), 1),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("img", { src: _ctx.testImage }, null, 8, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_ButtonStartTest, {
          class: "btn-start-test",
          onClick: _ctx.goAhead
        }, null, 8, ["onClick"])
      ]),
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_ButtonExternalLink, {
          label: "Comprar teste com sigilo",
          link: "https://shop.chembio.com.br/"
        })
      ]),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_ButtonExternalLink, {
          label: "Encontrar uma farmácia",
          link: "https://saude.clinicarx.com.br/"
        })
      ])
    ]),
    _createVNode(_component_base_footer, { class: "mb-4" })
  ]))
}